<template>
	<div
		class="toggle border"
		:class="[{ active: value, disabled }, toggleClasses]"
		@click="toggle()"
	>
		<div
			class="circle display-flex bg-white-base border border-white-darker-4"
			:class="circleClasses"
		>
			<b-icon :class="iconClasses">
				<icon-done v-if="value" />
				<icon-clear v-else />
			</b-icon>
		</div>
	</div>
</template>

<script>
import BIcon from './Icon.vue';
import IconDone from '../icons/icon-done.svg';
import IconClear from '../icons/icon-clear.svg';
export default {
	name: 'b-toggle',
	components: {
		BIcon,
		IconDone,
		IconClear
	},
	props: {
		/**
		 * @model
		 * Se true toggle é exibido como selecionado, caso contrário é exibido como não selecionado.
		 */
		value: {
			type: Boolean,
			default: false
		},
		/**
		 * Se true toggle é exibido desabilitado, não sendo possível interagir com o componente
		 */
		disabled: {
			type: Boolean,
			default: false
		}
	},
	methods: {
		toggle() {
			if (!this.disabled) {
				/**
				 * Evento emitido quando toggle é clicado
				 * @property {value}
				 * @type {input}
				 */
				this.$emit('input', !this.value);
			}
		}
	},
	computed: {
		toggleClasses() {
			return this.disabled
				? 'bg-white-darker-3 border-white-darker-3'
				: this.value
				? 'bg-green-base border-green-lighter-1'
				: 'bg-white-darker-2 border-white-darker-4';
		},
		circleClasses() {
			return this.disabled
				? 'bg-white-darker-1 border-white-darker-3'
				: this.value
				? 'bg-white-base border-green-lighter-1'
				: 'bg-white-base border-white-darker-4';
		},
		iconClasses() {
			return this.disabled ? 'white-darker-3' : this.value ? 'green-base' : 'ink-lighter-1';
		}
	}
};
</script>

<style lang="scss">
$duration: 0.3s;
div.toggle {
	width: 6.5rem;
	min-width: 6.5rem;
	position: relative;
	height: 3.6rem;
	box-sizing: border-box;
	border-radius: 1.8rem;
	position: relative;
	transition: background $duration;
	cursor: pointer;
	div.circle {
		width: 3rem;
		height: 3rem;
		border-radius: 1.6rem;
		position: absolute;
		top: 0.2rem;
		left: 0.2rem;
		transition: left $duration;
		i {
			width: 2.8rem;
			height: 2.8rem;
			transform: translateY(0);
			svg {
				width: 100%;
			}
		}
	}
	&.active {
		div.circle {
			left: 3rem;
		}
	}
	&.disabled {
		cursor: not-allowed !important;
	}
}
</style>

<docs>
    Toggle

    As importações dos arquivos abaixo são necessárias para o funcionamento do componente:
    - styling.scss
    - position.scss

    ```js
    var active = true;
    var notActive = false;
    <b-toggle disabled style="margin-bottom:4px;"/>
    <b-toggle v-model="active" style="margin-bottom:4px;"/>
    <b-toggle v-model="notActive" style="margin-bottom:4px;"/>
    ```

</docs>
